/**
 * Lightweight on-brand toast helper. Renders a single dark pill at the bottom
 * of the screen (above safe area) for ~3s. Replaces alert() across the app.
 */

let containerEl = null;

function ensureContainer() {
  if (containerEl) return containerEl;
  containerEl = document.createElement('div');
  containerEl.id = 'runium-toast-container';
  containerEl.style.cssText = [
    'position:fixed',
    'left:50%',
    'transform:translateX(-50%)',
    'bottom:calc(env(safe-area-inset-bottom, 0px) + 24px)',
    'z-index:99999',
    'pointer-events:none',
    'display:flex',
    'flex-direction:column',
    'gap:8px',
    'align-items:center',
    'max-width:calc(100vw - 32px)',
  ].join(';');
  document.body.appendChild(containerEl);
  return containerEl;
}

export function toast(message, opts = {}) {
  if (typeof document === 'undefined') return;
  const variant = opts.variant || 'default'; // 'default' | 'error' | 'success'
  const ms = opts.duration ?? 3000;

  const root = ensureContainer();
  const el = document.createElement('div');
  el.textContent = message;

  const palette = {
    default: { bg: 'rgba(31, 41, 55, 0.96)', border: 'rgba(75, 85, 99, 0.6)', text: '#f3f4f6' },
    error:   { bg: 'rgba(127, 29, 29, 0.96)', border: 'rgba(248, 113, 113, 0.5)', text: '#fee2e2' },
    success: { bg: 'rgba(6, 78, 59, 0.96)', border: 'rgba(52, 211, 153, 0.5)', text: '#d1fae5' },
  };
  const c = palette[variant] || palette.default;

  el.style.cssText = [
    `background:${c.bg}`,
    `color:${c.text}`,
    `border:1px solid ${c.border}`,
    'backdrop-filter:blur(12px)',
    '-webkit-backdrop-filter:blur(12px)',
    'padding:12px 18px',
    'border-radius:14px',
    'box-shadow:0 8px 24px rgba(0, 0, 0, 0.35)',
    'font-size:14px',
    'font-weight:500',
    'line-height:1.35',
    'text-align:center',
    'opacity:0',
    'transform:translateY(8px)',
    'transition:opacity 0.18s ease, transform 0.18s ease',
    'pointer-events:auto',
    'max-width:360px',
  ].join(';');

  root.appendChild(el);
  // trigger transition
  requestAnimationFrame(() => {
    el.style.opacity = '1';
    el.style.transform = 'translateY(0)';
  });

  setTimeout(() => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(8px)';
    setTimeout(() => el.remove(), 220);
  }, ms);
}

export const toastError = (msg, opts) => toast(msg, { variant: 'error', ...opts });
export const toastSuccess = (msg, opts) => toast(msg, { variant: 'success', ...opts });
